// removed by extract-text-webpack-plugin
module.exports = {"root":"EnquiryForm__root__3cfao","icon":"EnquiryForm__icon__ekhrJ","heading":"EnquiryForm__heading__P3FO6","field":"EnquiryForm__field__1vJ3B","error":"EnquiryForm__error__2b-GS","fieldRoot":"EnquiryForm__fieldRoot__CcnlN"};


//////////////////
// WEBPACK FOOTER
// ./src/forms/EnquiryForm/EnquiryForm.css
// module id = 1717
// module chunks = 0